import type { RouteObject } from 'react-router';

import { MobileLayout } from '../components';
import { CheckoutFormOnDevice } from '../pages/CheckoutFormOnDevice/CheckoutFormOnDevice';
import { LinkBankOnDevice } from '../pages/LinkBankOnDevice/LinkBankOnDevice';
import { LoginOnDevice } from '../pages/LoginOnDevice/LoginOnDevice';
import { orderCompleteRoute } from './orderCompleteRoutes';

export const mobileDeviceRoutes = (): RouteObject => ({
  children: [
    {
      element: <CheckoutFormOnDevice />,
      path: 'cart/:cartUuid',
    },
    {
      element: <LoginOnDevice />,
      path: `login`,
    },
    {
      element: <LinkBankOnDevice />,
      path: `link-bank`,
    },
    orderCompleteRoute(true),
  ],
  element: <MobileLayout />,
  path: 'mobile',
});
